'use client';

import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { FormError } from '@/components/form/formError';
import { EonMark } from '@/components/layout/shared/eonMark';

// The centered, branded card shell shared by every login-v2 step: the Eon mark,
// the step content, and (when present) the server-error banner below it.
export const LoginCard = t0 => {
  const $ = _c(10);
  const {
    children,
    error,
    errorTestId: t1,
    width: t2
  } = t0;
  const errorTestId = t1 === undefined ? "login-v2-error" : t1;
  const width = t2 === undefined ? "400px" : t2;
  let t3;
  if ($[0] !== width) {
    t3 = {
      width,
      maxWidth: "100%",
      margin: "auto",
      alignItems: "center",
      gap: "40px",
      paddingY: "40px"
    };
    $[0] = width;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <EonMark />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== error || $[4] !== errorTestId) {
    t5 = error && <FormError message={error} testId={errorTestId} />;
    $[3] = error;
    $[4] = errorTestId;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t3 || $[8] !== t5) {
    t6 = <Stack sx={t3}>{t4}{children}{t5}</Stack>;
    $[6] = children;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};